// Typography
export const font = `avenir next,avenir,Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif`;
export const monospace = `"SF Mono", "Roboto Mono", Menlo, monospace`
export const fontSizes = [14,16,18,27,36,48,64,72,96]
export const weights = [200,400,700]

// Colors
export const colors = {
  "base": "#0077cc",
  "lite": "#f6f6f6",
  "blue": "#0077cc",
  "blue0": "#e4f1fa",
  "blue1": "#c7e1f4",
  "blue2": "#a5cfed",
  "blue3": "#7dbae5",
  "blue4": "#4b9fdb",
  "blue5": "#0077cc",
  "blue6": "#006bb8",
  "blue7": "#005ea1",
  "blue8": "#004d84",
  "blue9": "#00375e",
  "black": "#000",
  "gray": "#adb4b9",
  "gray0": "#f9f9fa",
  "gray1": "#eceeef",
  "gray2": "#dee1e3",
  "gray3": "#cfd3d7",
  "gray4": "#bfc5c9",
  "gray5": "#adb4b9",
  "gray6": "#98a1a8",
  "gray7": "#7f8b93",
  "gray8": "#606e79",
  "gray9": "#374047",
  "green": "#11cc00",
  "green0": "#e6fae4",
  "green1": "#caf4c6",
  "green2": "#aaeda4",
  "green3": "#84e57b",
  "green4": "#54da48",
  "green5": "#11cc00",
  "green6": "#0fb900",
  "green7": "#0ea200",
  "green8": "#0b8700",
  "green9": "#086100",
  "red": "#dd0000",
  "red0": "#fbeaec",
  "red1": "#f6d3d6",
  "red2": "#f1b8bc",
  "red3": "#ea969d",
  "red4": "#e16973",
  "red5": "#cc0011",
  "red6": "#b9000f",
  "red7": "#a2000e",
  "red8": "#87000b",
  "red9": "#610008",
}

// layout
export const breakpoints = ['32em','48em','64em','80em']
export const space = [0,4,8,16,32,64,128]

export default {
  font,
  weights,
  fontSizes,
  colors,
  breakpoints,
  space
}
